// extracted by mini-css-extract-plugin
export default {"scrollbar-shift":"adjustForScrollbar_scrollbar-shift__eb4f7"};